// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"5db1484e","182":"c917689a","767":"38bd564e"}[chunkId] + ".chunk.css";
};